module.exports = __webpack_public_path__ + "img/girl.238ea55f.png";